import React from "react";
import propTypes from "prop-types";
import classnames from "classnames";
import { createDataAttributes } from "../../utilities";

import "./StatusPill.scss";

const StatusPill = ({ text, color, className, dataAttrib, ...rest }) => {
  const containerClasses = classnames(
    "uikit__status-pill",
    "uikit__status-pill__" + color,
    className
  );
  return (
    <span
      className={containerClasses}
      {...createDataAttributes(dataAttrib)}
      {...rest}
    >
      {text}
    </span>
  );
};

StatusPill.propTypes = {
  color: propTypes.oneOf([
    "red",
    "yellow",
    "white",
    "lt-grey",
    "grey",
    "orange",
    "lt-blue",
    "blue",
    "green",
    "purple"
  ]),
  text: propTypes.string.isRequired,
  className: propTypes.string,
  dataAttrib: propTypes.arrayOf(Object)
};

StatusPill.defaultProps = {
  color: "white"
};

export default StatusPill;
